import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Cookies from 'js-cookie';
import Wrapper from '../../layouts/Wrapper';
import AccountPanel from '../../components/user/AccountPanel';
import AccountProfile from './AccountProfile';
import AccountPassword from './AccountPassword';
import AccountHistory from './AccountHistory';
// import AccountResults from './AccountResults';
// import AccountBonuses from './AccountBonuses';
import useWindowSize from '../../hooks/useWindowSize';

function UserAccount() {
  const { page } = useParams();
  const lang = Cookies.get('i18next') || 'en';
  const navigate = useNavigate();
  const [showContent, setShowContent] = React.useState(false);
  const pageTransition = {
    type: 'tween',
    ease: 'easeInOut',
    duration: 0.4,
  };

  const pageVariants = {
    initial: { opacity: 0, y: '-100%' },
    in: { opacity: 1, y: '0%' },
    out: { opacity: 0, y: '100%' },
  };
  const { width } = useWindowSize();
  useEffect(() => {
    if (!page) {
      setShowContent(false);
    } else {
      setShowContent(true);
    }
  }, [page]);
  const handleCloseMenu = () => {
    navigate(`/${lang}/account`);
  };
  if (page && (page !== 'history' && page !== 'profile' && page !== 'password')) {
    navigate(`/${lang}/404`);
  }
  return (
    <Wrapper>
      <div
        style={{
          overflow: 'hidden',
          position: 'relative',
        }}
        className="container small user"
      >
        <div className="user__account">
          {(!showContent || width > 768) && <AccountPanel />}
          {(showContent || width >= 768) && (
          <AnimatePresence mode="wait">
            <motion.div
              className="user__account-content"
              key={page}
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              {(page === 'profile' || (!page && width > 768)) && <AccountProfile handleCloseMenu={handleCloseMenu} />}
              {page === 'password' && <AccountPassword handleCloseMenu={handleCloseMenu} />}
              {page === 'history' && <AccountHistory handleCloseMenu={handleCloseMenu} />}
              {/* {page === 'results' && <AccountResults handleCloseMenu={handleCloseMenu} />} */}
              {/* {page === 'bonuses' && <AccountBonuses handleCloseMenu={handleCloseMenu} />} */}
            </motion.div>
          </AnimatePresence>
          )}

        </div>
      </div>
    </Wrapper>
  );
}

export default UserAccount;
